module.exports = {
  "FoodB_manager_Kwwl_Cjll": "第8天至活动结束，投入{{amount1}}~{{amount2}}，平台补贴{{rate1}}",
  "FoodB_manager_jhXU_ptlV": "你的广告被点击的总次数",
  "FoodB_manager_OKSu_qWyl": "补贴期内不可编辑，{{end_data}}活动结束后开放编辑",
  "FoodB_APP_PxtZ_SCXD": "智能营销投资额管理",
  "FoodB_images_tgoc_AhLQ": "已上架",
  "FoodC_information_uZqE_salQ": "勾选后，即表示接受条款",
  "FoodB_Overview_AasD_LvfW": "查看更多",
  "FoodB_manager_sgsH_EpiM": "天",
  "FoodB_APP_rhVY_pJAy": "每日最高投资额已成功保存",
  "FoodB_Workflow_tjxT_OoQU": "仅支持上传JPG，JPEG和PNG格式的图片，尺寸需在450x450到1124x1124像素之间。",
  "FoodB_manager_HqjV_CxOA": "你的预算未达到活动要求，添加预算可以获得活动补贴",
  "FoodB_manager_ntwn_wBNk": "广告曝光人数",
  "FoodB_images_qpuG_DTcO": "差图",
  "FoodB_manager_aCSR_lQaQ": "周",
  "FoodB_modification_Confirmation_ehVU": "确认",
  "FoodB_guidance_ympr_VDEB": "八五折",
  "FoodB_V_Cancel_ELKJ": "取消",
  "FoodB_ads_PRAv_IxKG": "这是您针对此次广告所支出的总金额",
  "FoodB_manager_BMOX_RrUm": "前7天免费",
  "FoodB_APP_bYTM_LhKX": "保存",
  "FoodB_0526_ZwcV_xubO": "完成配送",
  "FoodB_images_zcVM_dgvs": "无图",
  "FoodB_0526_Ugoi_wHIL": "我已到达地址",
  "FoodB_202403_iElx_PrgH": "无访问相册权限，请您开启权限后重试",
  "FoodB_IOS_bkpb_pDAZ": "下架成功",
  "FoodB_Workflow_wQEs_xfyz": "请输入",
  "FoodB_0526_ALSJ_vOIv": "验证并继续",
  "FoodB_ads_iUsb_wdEa": "投放广告",
  "FoodB_ads_JKaI_zpdU": "重启失败",
  "FoodB_optimization_lHJe_wjVZ": "{{num}}月销",
  "FoodB_Workflow_YhcO_slrY": "请选择原因",
  "FoodB_structure_Next_step_GKKZ": "下一步",
  "FoodB_202403_tIbT_QIhv": "已下载成功",
  "FoodB_structure_If_the_qaXe": "若菜品为下列菜品的必要项，下架会使得整个菜品下架。",
  "FoodB_edit_iIzf_VxWT": "选项组价格",
  "FoodB_APP_mEnV_wsTd": "投资额调整日志",
  "FoodB_202601_RpBl_cvEL": "选项库存",
  "FoodB_ads_Vuno_mXMy": "暂停",
  "FoodB_0526_xxjK_BrKm": "验证客户确认码",
  "FoodB_IOS_UOug_fSFt": "收起",
  "FoodB_manager_ZQKX_FOdY": "今天至{{trail_end_date}}免费",
  "FoodB_202507_Mmtm_bVsd": "验证码",
  "FoodB_ads_wEEv_oKzi": "来自广告的销售额",
  "FoodB_manager_cfaa_kvuC": "广告曝光次数",
  "FoodB_ads_AbgR_WCms": "投资回报率",
  "FoodB_APP_xAjf_jDPk": "未设置",
  "FoodB_structure_The_group_yaQn": "自定义选项组的{{group_name}}信息不完整，无法上架。请重新编辑选项组",
  "FoodB_Workflow_GJjA_zxpx": "原因",
  "FoodB_Workflow_LMPG_cGGe": "取消",
  "FoodB_ads_fbjh_KkrE": "共享{{amount}}",
  "FoodB_1_rrzc_FYjd": "勾选后，即表示接受",
  "FoodB_b_Merchant_activities_AOMe": "招商活动",
  "FoodB_ads_kQlR_vLwo": "常见问题",
  "FoodB_edit_Kpjr_ClVJ": "提交修改",
  "FoodB_event_gnlU_HgeW": "平台补贴",
  "FoodB_signup_Rpjk_VExr": "请勾选同意协议",
  "FoodB_structure_Only_the_TlfX": "只下架本菜品",
  "FoodB_manager_kgoO_KDWx": "广告订单数",
  "FoodB_images_hyZS_lUdA": "销量升序",
  "Gattaran_System_stOW_oOzc": "编辑",
  "FoodB_202507_zUrC_RTLN": "验证码不可为空",
  "FoodB_guidance_qLuz_cdFT": "折扣大于15% OFF可以参加套餐招商活动",
  "FoodB_0526_pago_jZCL": "返回",
  "FoodB_202412_AFEo_IMDT": "查看",
  "FoodB_images_Odmy_EpkO": "重图",
  "全部": "",
  "FoodB_notification_hZjl_FphL": "您的商品名称或描述中包含了无效的词汇，请检查后重试！",
  "FoodB_202507_VtFw_lWoZ": "验证码仅支持6位数字",
  "FoodB_0526_CJIS_cGuT": "店铺配送",
  "FoodB_end_wXDp_EzMh": "不能为空",
  "FoodB_202601_VXKL_AVFs": "将暂停售卖",
  "FoodB_Notification_cXDd_hXys": "请确认",
  "FoodB_structure_There_are_IFaR": "存在与当前菜品同名的菜品，请选择下架的范围.",
  "FoodB_ads_eLJV_rpQs": "重启成功",
  "FoodB_images_SJsQ_RTPC": "默认",
  "FoodB_202507_Kvbw_JjQU": "邀请已过期，请联系门店重新获取",
  "FoodB_ads_LYLE_IJlq": "广告协议和条款",
  "FoodB_ads_JrZk_DAPd": "创建我的广告计划",
  "FoodB_end_tShf_yvRL": "请输入",
  "soda-b-web-i18n---必选": "必选",
  "FoodB_Workflow_TGPT_ERNF": "提交",
  "FoodB_202507_pyLz_EIhG": "验证并继续",
  "FoodB_raise_GzoV_LxqP": "存在改价失败的菜品，请到{{sys}}端查看详情！",
  "FoodB_end_jDIn_MChP": "店铺名称",
  "FoodB_IOS_aPdf_nqLr": "图片状态",
  "FoodB_ads_dOkB_VPYp": "广告投放门店",
  "FoodB_Subscribe202412_zlrO_JCcA": "提示",
  "FoodB_20240530_DIPS_Umqk": "我知道了",
  "FoodB_Refund_VgKI_KAdX": "菜品名称",
  "FoodB_structure_Remove_items_mzeF": "下架同名菜品（包括子菜品）",
  "FoodB_20220201_Confirmation_uFDW": "确认",
  "FoodB_0526_CWJT_tJDS": "当你与顾客见面并把食物交接他们时，请他们提供{{number4}}位数字的验证码，以确认送达。",
  "FoodB_manager_dbWL_uoLT": "你的广告被浏览的总次数",
  "FoodB_202507_AaJV_ONrK": "直接下载",
  "FoodB_202507_eldX_PSOm": "重新发送",
  "FoodB_202601_XPTD_CEFY": "库存售罄，已暂停售卖",
  "FoodB_examination_RLMB_cTnU": "该菜品为禁售的高价菜，请您调整菜品和选项的价格，保证为低于堂食或其他平台的价格再上架菜品。",
  "FoodB_b_rWzS_qxWT": "最少可输入{{amount}}，投资金额过低效果不好",
  "FoodB_APP_PblC_TgZp": "每日最高投资额",
  "FoodB_images_elYf_pCKJ": "上架",
  "FoodB_202601_aEjt_IJpA": "设置库存",
  "FoodB_manager_KMon_Ucmi": "7天后最高补贴至{{{max_rate}}}",
  "FoodB_optimization_Image_Requirements_RAjc": "图片要求：格式必须为JPG或PNG，大小不超过5MB",
  "FoodB_manager_Pmbs_CYnh": "参加活动可获得总计{{amount}}天的广告补贴，店铺第一次投放广告前7天免费",
  "FoodB_examination_jQot_WFxD": "高价菜禁售",
  "FoodB_dishes_golj_IhqE": "该菜品为禁售的高价菜，请修改至“管控价格”以下再上架菜品。",
  "FoodB_Workflow_DPbq_FztV": "上传证据",
  "FoodB_lines__item_gLep": "{{item}} 上下架状态修改失败，原因：",
  "FoodB_Workflow_BldJ_kyRF": "备注",
  "FoodB_ads_kkCY_VhnR": "广告详情",
  "FoodB_202601_CdHf_ZlRj": "库存",
  "FoodB_0526_YWxv_qCMp": "验证订单查询码",
  "FoodB_diagnosis_Add_the_ROcc": "请添加套餐适用人数",
  "FoodB_images_NRvd_CfNM": "菜品曝光位置",
  "FoodB_images_kqnL_zpUk": "高质量的图片可以吸引更多用户下单",
  "FoodB_manager_rzAQ_djgI": "{{start_data}}至{{end_data}}平台承担{{p_budget}}/天，门店承担{{b_budget}}/天",
  "FoodB_manager_HaIz_XbUw": "您可以到广告详情页面查看广告收益和更多内容",
  "FoodB_IOS_uqRa_ZgjI": "上架成功",
  "FoodB_manager_SKhT_KcPn": "广告预算",
  "FoodB_structure_This_item_Kjzb": "此菜品已应用在下列菜品的选项组中，将同时在下列菜品的选项组中下架。",
  "FoodB_0526_obJO_XULq": "步骤{{number1}}",
  "FoodB_manager_ZTpO_CxTr": "今天至{{end_data}}平台承担{{p_budget}}/周，门店承担{{b_budget}}/周",
  "FoodB_IOS_GAPD_nKPg": "售卖状态",
  "FoodB_images_Ifqh_ZbIZ": "全部",
  "FoodB_Workflow_oCVA_DKpq": "图片格式支持{{format}}，且分辨率不能低于{{ratio}}。",
  "FoodB_end_btsz_MEkI": "操作日志",
  "FoodB_ads_GmKW_brRz": "这是看到广告后7天内下单的顾客所产生的总销售额",
  "FoodB_202403_GUuf_Hxvh": "DiDi Your Business",
  "FoodB_edit_FUgf_iAPR": "系统错误，请重试！",
  "FoodB_images_Ruvq_UOGP": "销量降序",
  "FoodB_ads_hsyI_CluZ": "广告支出",
  "FoodB_APP_Pcvl_NpRz": "请输入",
  "FoodB_images_sDvo_WhBT": "无图或重图的菜品将无法参加下图所示的活动，从而影响菜品曝光效果。",
  "FoodB_edit_EauY_eVbs": "在套餐或活动中的菜品无法修改价格",
  "FoodB_ads_EUKq_wQqg": "自定义",
  "FoodB_b_eskb_LyNU": "最大可输入{{amount}}，投资金额过高效果不好",
  "FoodB_3_Meij_rAcc": "暂无搜索结果",
  "FoodB_manager_jDsw_neeZ": "补贴后广告总预算为{{total_amount}}/天",
  "FoodB_manager_PNYI_bdhw": "请点击{页面左上角}返回列表",
  "FoodB_manager_QWyb_fTPV": "{{date}}补贴结束，广告预算恢复至{{b_budget}}/周",
  "FoodB_202601_cyGw_MMum": "不限库存",
  "FoodB_diagnosis_Fill_in_izgd": "请填写菜品描述",
  "FoodB_manager_lrhZ_GgWG": "{{start_data}}至{{end_data}}平台承担{{p_budget}}/周，门店承担{{b_budget}}/周",
  "FoodB_0526_Ohci_xuvI": "业务维护正在进行中，敬请期待",
  "FoodB_0526_HUpD_BgTa": "您需要订单查询码和客户确认码以确认送达。",
  "FoodB_manager_Vavg_QJRU": "今天至{{end_data}}平台承担{{p_budget}}/天，门店承担{{b_budget}}/天",
  "FoodB_ads_mCxj_GQTc": "出价（按用户每次点击出价）",
  "FoodB_202311_BGpD_RoKX": "没有更多了",
  "FoodB_Brazil_ajzJ_JuVl": "品牌加盟模式约定您无权限操作，如需操作，请联系销售人员",
  "FoodB_images_dCkE_owJP": "重复图片会对菜品曝光和用户下单产生负面影响。",
  "FoodB_list_pycq_NFTr": "展开",
  "FoodB_guidance_KjqW_ZOOL": "折扣大于20% OFF会给套餐带来更多销量",
  "soda-b-web-i18n---可选": "可选",
  "FoodB_202507_IeTZ_IsVt": "验证码错误，请重试",
  "FoodB_list_RMhg_oxdJ": "收起",
  "soda-b-web-i18n---请输入价格": "请输入价格",
  "FoodB_202507_TYLB_oGxx": "成为配送员",
  "FoodB_manager_tfuO_mmOQ": "投入{{amount3}}及以上，平台补贴{{rate3}}",
  "FoodB_ads_Mhsz_vxcz": "暂停后，您店铺的曝光将减少，这可能会影响您的订单。",
  "FoodB_0526_ItLx_NtXl": "输入的查询码未识别，请重试。",
  "FoodB_structure_Available_items_YZlI": "上架菜品",
  "FoodB_manager_UQMz_EKvg": "广告点击次数",
  "soda-b-web-i18n---请选择": "请选择",
  "FoodB_Workflow_sLBZ_kEUz": "申诉",
  "FoodB_structure_Confirmation_KdZD": "确认",
  "FoodB_202507_lSPc_azJu": "您好，{{nick_name}}邀请您加入门店{{store_name}}的配送团队",
  "FoodB_images_dkwU_DozC": "下架",
  "FoodB_ads_xHIG_ssdt": "投放人群",
  "FoodB_ads_jnGH_TBtE": "更新至{{date}}",
  "FoodB_manager_dbGg_urLm": "保存修改",
  "FoodB_ads_EuaQ_gUWs": "每周预算",
  "FoodB_end_vWCI_Khdj": "店铺ID",
  "FoodB_manager_cYvu_RUOJ": "一周内平均每日的支出金额，每周总支出金额不会超过每日预算的七倍",
  "FoodB_menu_ezpD_HgJQ": "配送",
  "FoodB_manager_Zkso_jGUU": "补贴后广告总预算为{{total_amount}}/周",
  "FoodB_I_FKuu_NKAq": "提交成功",
  "FoodB_guidance_KPTM_jtce": "七折",
  "FoodB_202601_sCuN_CshI": "菜品库存",
  "FoodB_Management_ETTC_atmq": "提示",
  "FoodB_0526_LSWB_SqBa": "查询码",
  "FoodB_Workflow_YTgN_Kqvj": "顾客评价",
  "FoodB_202507_KAIz_QuzG": "下载并安装App后，使用验证成功的手机号登录，即可开始配送",
  "FoodB_ads_SKdz_cIQv": "这是您每支出{{amount}}的广告费用所获得的销售回报。该金额按照来自广告的销售额除以所支出的广告金额计算得出。",
  "FoodB_202403_Oupx_AERj": "下载失败，请您重试",
  "FoodB_ads_fFZs_fhfw": "确定要暂停广告吗",
  "FoodB_one_Create_categories_NYkB": "请先创建类别",
  "FoodB_202507_pnqc_SLIH": "{{number}}验证通过！",
  "FoodB_0526_BiXD_Hdyk": "步骤{{number2}}",
  "FoodB_ads_ohud_CQNg": "重启",
  "FoodB_0526_wOWe_bCYw": "输入的客户确认码未识别，请重试。",
  "FoodB_manager_Taew_Vhya": "累计有多少用户看到了你的广告",
  "FoodB_record_aMyR_GHwi": "新建",
  "FoodB_ads_TBRW_mcgC": "查看",
  "FoodB_guidance_TyKs_OJEe": "价格不能为0",
  "FoodB_Workflow_NsGd_FBUJ": "提交成功",
  "Gattaran_app_wQyy_gBIH": "此功能只能在商家端使用，{{app}}暂不支持",
  "FoodB_ads_aBTZ_puGq": "您的广告计划",
  "FoodB_manager_pkmQ_slMM": "活动报名成功",
  "FoodB_edit_OzpO_pQjy": "编辑菜品",
  "FoodB_0526_RjfK_pdye": "感谢您的配送，订单已经确认送达。",
  "FoodB_APP_zgwc_zcsv": "请设置每个店铺每天最高投资额，您每天的花费不会超过最高值",
  "FoodB_structure_Dishes_off_DpDW": "下架菜品",
  "FoodB_manager_bfcy_TuLs": "每周支出的广告费最大值",
  "FoodB_ads_AUHA_UKTn": "生效状态",
  "FoodB_images_mWCv_qwcI": "已下架",
  "FoodB_diagnosis_Package_prices_HhZb": "套餐价格超过最高价格",
  "FoodB_IOS_DuJM_XIww": "展开",
  "FoodB_app_rJMe_JvWP": "堂食同款：{{DineInSpreadRatio}}%价差",
  "FoodB_manager_WiiZ_fQTr": "广告点击人数",
  "FoodB_202507_jFRj_JuzW": "获取验证码",
  "FoodB_manager_tluR_ydNq": "修改成功",
  "FoodB_App__CeNy": "暂无推荐套餐",
  "FoodB_202507_gJQz_KNsm": "请通过短信验证，协助我们确认以下手机号归您所有且可以正常使用：",
  "soda-b-web-i18n---图片不合法": "图片不合法",
  "FoodB_menu_TLDI_rbsq": "自提",
  "Gattaran_System_FPHM_FNhp": "广告计划",
  "FoodB_manager_gCEg_QRci": "{{end_data}}之前重启广告，依然可以享受平台补贴",
  "FoodB_end_txmi_EUkK": "创建成功",
  "FoodB_guidance_tIZK_FnCu": "八折",
  "FoodB_images_RTGc_aPGv": "想为门店菜品拍摄图片？试试新的相机拍摄功能吧！",
  "FoodB_end_EXUZ_AybF": "我已阅读并同意",
  "FoodB_images_yEwu_BOgv": "查看更多",
  "FoodB_manager_YJWG_TGEr": "投入{{amount2}}~{{amount3}}，平台补贴{{rate2}}",
  "FoodB_examination_iFla_jDwD": "存在禁售的高价菜品，请到{{sys}}端查看详情！",
  "FoodB_0526_WpAq_pLIl": "您到达配送地点了吗？",
  "FoodB_ads_zdck_cALt": "数据效果",
  "FoodB_manager_OJaX_kWqN": "广告回报率",
  "FoodB_manager_zkAd_zMmA": "累计有多少用户点击了你的广告",
  "FoodB_0526_rIpi_tOxQ": "订单定位码可以在订单收据上找到，它由{{number3}}位数字组成。它可以用来识别订单，也可以作为联系用户的分机号码。",
  "FoodB_diagnosis_Store_Gallery_izRn": "门店图库",
  "Gattaran_System_MdOu_YQGa": "每日预算",
  "FoodB_202507_oTId_ZJEY": "下载App",
  "FoodB_APP_pPJg_kXTB": "操作人",
  "FoodB_Packages_WVQT_trjL": "选项名称",
  "FoodB_edit_GGaD_NBFy": "菜品价格",
  "FoodB_manager_cAxE_aMhz": "用户看到广告后七天内下的订单数量",
  "soda-b-web-i18n---请输入项目名称": "请输入项目名称",
  "FoodB_APP_ndJV_wijx": "设置投资额",
  "FoodB_ads_WAjG_IoqX": "广告",
  "FoodB_ads_mKyB_UXoD": "活动规则",
  "FoodB_app_LKsL_pZNy": "Black同款：{{BlackSpreadRatio}}%价差",
  "FoodB_manager_lvpx_Fggm": "第8天至活动结束，平台补贴{{rate}}",
  "FoodB_combination_dMkH_fHZW": "只能在{{amount1}}~{{amount2}}区间内填写",
  "Gattaran_System_wrVY_PjDQ": "计划名称",
  "FoodB_manager_Adkb_bXXA": "{{date}}补贴结束，广告预算恢复至{{b_budget}}/天",
  "FoodB_guidance_LLRv_LmOz": "可以在super special专区获得更多曝光",
  "搜索": "",
  "未搜索到相关菜品": "",
  "暂无菜品": "",
  "搜索结果": "",
  "菜品名称、加料": "",
  "下架": "",
  "上架": "",
  "菜品列表": ""
}